import React from 'react';
import { fileExtensionToType, FileTypes } from '@wix/ricos';

import ImageIcon from './icons/IMAGE.svg';
import WordIcon from './icons/WORD.svg';
import ExcelIcon from './icons/EXCEL.svg';
import PowerPointIcon from './icons/POWERPOINT.svg';
import PDFIcon from './icons/PDF.svg';
import VideoAudioIcon from './icons/VIDEO_AUDIO.svg';
import MISCIcon from './icons/MISC.svg';

interface IFileIconProps {
  extension: string;
}

export function FileIcon(props: IFileIconProps) {
  const type = fileExtensionToType(props.extension.toLowerCase());

  switch (type) {
    case FileTypes.IMAGE:
      return <ImageIcon />;

    case FileTypes.VIDEO:
    case FileTypes.AUDIO:
      return <VideoAudioIcon />;

    case FileTypes.WORD:
      return <WordIcon />;

    case FileTypes.EXCEL:
      return <ExcelIcon />;

    case FileTypes.POWERPOINT:
      return <PowerPointIcon />;

    case FileTypes.PDF:
      return <PDFIcon />;

    case FileTypes.ARCHIVE:
    case FileTypes.MISC:
    default:
      return <MISCIcon />;
  }
}

FileIcon.displayName = 'FileIcon';
